/**
 * Vlastní ikony (SVG, obrys v barvě textu) – na všech telefonech vypadají stejně,
 * na rozdíl od emoji. Kreslené na mřížce 24 × 24.
 */
import type { EventType } from '../db/model';

const P: Record<string, string> = {
  // navigace
  hive: 'M5 9h14v11H5zM4 9l8-5 8 5M5 13h14M5 17h14M10 20v-2h4v2',
  qr: 'M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3M8 8h3v3H8zM13 8h3v3h-3zM8 13h3v3H8zM13 13h3v3h-3z',
  chart: 'M4 20h16M7 20v-6M12 20V8M17 20v-9',
  gear: 'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM19.4 13.5l1.6 1.2-1.8 3.1-1.9-.7a7.6 7.6 0 0 1-2 1.2l-.3 2h-3.6l-.3-2a7.6 7.6 0 0 1-2-1.2l-1.9.7-1.8-3.1 1.6-1.2a7.4 7.4 0 0 1 0-2.4L3.4 10l1.8-3.1 1.9.7a7.6 7.6 0 0 1 2-1.2l.3-2h3.6l.3 2a7.6 7.6 0 0 1 2 1.2l1.9-.7L21 10l-1.6 1.1a7.4 7.4 0 0 1 0 2.4z',
  // zápisy
  inspection: 'M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM15.2 15.2 20 20',
  treatment: 'M9 3h6M10 3v3l-3 3v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9l-3-3V3M12 12v5M9.5 14.5h5',
  varroa: 'M12 17c3 0 5-2.2 5-5s-2-5-5-5-5 2.2-5 5 2 5 5 5zM7.5 9.5 4 8M7 12H3.5M7.5 14.5 4 16M16.5 9.5 20 8M17 12h3.5M16.5 14.5 20 16M10 7.5 9 5M14 7.5 15 5',
  feeding: 'M5 10h14l-1.5 9a2 2 0 0 1-2 1.7h-7a2 2 0 0 1-2-1.7zM8 14c1.3-1 2.7-1 4 0s2.7 1 4 0M9 7c0-1.5 1-2 1-3M13 7c0-1.5 1-2 1-3',
  harvest: 'M7 8h10v11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2zM6 5h12v3H6zM7 12h10M12 12v3.5a1 1 0 0 0 2 0',
  queen_change: 'M4 18h16M5 18 3.5 8l5 4L12 6l3.5 6 5-4L19 18',
  split: 'M3 4h8v6H3zM13 14h8v6h-8zM7 10v4a2 2 0 0 0 2 2h4M11 13.5l2 2.5-2 2.5',
  swarm: 'M7 9a2 2 0 1 0 0-.01M16 7a2 2 0 1 0 0-.01M12 14a2 2 0 1 0 0-.01M6 17a1.5 1.5 0 1 0 0-.01M18 15a1.5 1.5 0 1 0 0-.01M10 5a1 1 0 1 0 0-.01',
  move: 'M3 7h11v9H3zM14 10h4l3 3v3h-7M7 19a2 2 0 1 0 0-.01M17 19a2 2 0 1 0 0-.01',
  status_change: 'M5 21V4M5 4h11l-2 4 2 4H5',
  super_change: 'M4 5h16v4.5H4zM4 9.5h16V14H4zM4 14h16v4.5H4zM10.5 7.2h3M10.5 11.7h3M10.5 16.2h3',
  note: 'M4 20h4l11-11-4-4L4 16zM13.5 6.5l4 4',
  // přehledy a ostatní
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4M8 14h2M14 14h2M8 17h2',
  snow: 'M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9M9.5 4.5 12 7l2.5-2.5M9.5 19.5 12 17l2.5 2.5',
  office: 'M3 21h18M5 21V10M9 21V10M15 21V10M19 21V10M3 10h18M12 3l9 5H3z',
  clipboard: 'M8 4h8v3H8zM6 5H5v16h14V5h-1M8 11h8M8 15h8M8 19h5',
  document: 'M6 3h9l4 4v14H6zM14 3v5h5M9 12h7M9 16h7',
  warning: 'M12 4 2.5 20h19zM12 10v4.5M12 17.5v.5',
  hourglass: 'M6 3h12M6 21h12M7 3c0 5 10 5 10 9s-10 4-10 9M17 3c0 5-10 5-10 9s10 4 10 9',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  print: 'M7 9V3h10v6M7 17H4v-8h16v8h-3M7 14h10v7H7z',
  table: 'M4 5h16v14H4zM4 10h16M4 15h16M10 5v14',
  refresh: 'M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7',
  camera: 'M4 8h3l2-3h6l2 3h3v12H4zM12 17a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
  check: 'M5 12.5 10 17.5 19 7',
  download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  upload: 'M12 16V5M7 10l5-5 5 5M5 20h14',
  share: 'M12 3v12M8 7l4-4 4 4M7 10H5v11h14V10h-2',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3',
  sun: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  pin: 'M12 21s-6-5.5-6-11a6 6 0 0 1 12 0c0 5.5-6 11-6 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
};

export type IconName = keyof typeof P | EventType;

export const EVENT_ICON_NAME: Record<EventType, IconName> = {
  inspection: 'inspection',
  treatment: 'treatment',
  varroa_check: 'varroa',
  feeding: 'feeding',
  harvest: 'harvest',
  queen_change: 'queen_change',
  split: 'split',
  swarm: 'swarm',
  move: 'move',
  status_change: 'status_change',
  super_change: 'super_change',
  note: 'note',
};

export function Icon({ name, size = 24, className, label }: { name: IconName; size?: number; className?: string; label?: string }) {
  const d = P[name as string] ?? P.note;
  return (
    <svg
      className={'icon' + (className ? ' ' + className : '')}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path d={d} />
    </svg>
  );
}

export function EventIcon({ type, size }: { type: EventType; size?: number }) {
  return <Icon name={EVENT_ICON_NAME[type]} size={size} />;
}
